export let Field;

(function (Field) {
  Field["RightsToOrganization"] = "rightsToOrganization";
  Field["FirstName"] = "firstName";
  Field["LastName"] = "lastName";
  Field["Email"] = "email";
  Field["WorldCountry"] = "worldCountry";
  Field["City"] = "city";
  Field["PostalCode"] = "postalCode";
  Field["Company"] = "company";
  Field["Address"] = "address";
  Field["IntellectualPropertyCategory"] = "intellectualPropertyCategory";
  Field["IntellectualPropertyOwner"] = "intellectualPropertyOwner";
  Field["IntellectualPropertyName"] = "intellectualPropertyName";
  Field["RegistrationNumber"] = "registrationNumber";
  Field["RightsConsistOf"] = "rightsConsistOf";
  Field["ProofOfRights"] = "proofOfRights";
  Field["Attachments"] = "attachments";
  Field["Brand"] = "brand";
  Field["Description"] = "description";
  Field["InfringingUrlsTextArea"] = "infringingUrlsTextArea";
  Field["IsLegalFooterConfirmed"] = "isLegalFooterConfirmed";
  Field["IllegalContentType"] = "illegalContentType";
  Field["ReportReasonType"] = "reportReasonType";
})(Field || (Field = {}));